/*
 * @Description: 
 */
/*
 * @Description: 
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'es6-promise/auto'
import 'babel-polyfill'

import iView from 'iview'
import 'iview/dist/styles/iview.css'
Vue.use(iView)

import { install as Axios } from './api'
import API from './api/url'
Vue.use(Axios);
Vue.prototype.API = API

import Tools from './utils/tools'
Vue.prototype.Tools = Tools



import './assets/css/config.css'

Vue.config.productionTip = false

new Vue({
  strict: false,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
